function openModalById(modalLink, event) {
	event.preventDefault();

	const modalId = modalLink.getAttribute("data-modal");
	const modal = document.getElementById(modalId);

	if (!modal) return;

	modal.style.display = "block";
	document.body.classList.add('modal-open');

	// Close button inside this modal
	const closeBtn = modal.querySelector('.mr-custom-modal-close');

	if (closeBtn) {
		closeBtn.onclick = function () {
			modal.style.display = "none";
			document.body.classList.remove('modal-open');
		};
	}

	// Close when clicking the overlay
	modal.onclick = function (e) {
		if (e.target === modal) {
			modal.style.display = "none";
			document.body.classList.remove('modal-open');
		}
	};
}